import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowRight } from 'react-icons/fa';
import { blogs as staticBlogs } from '../data/products';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Use static blogs data
    setBlogs(staticBlogs);
    setLoading(false);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="min-h-screen pt-20" data-testid="blog-page">
      {/* Hero Section */}
      <section className="bg-[#2E368F] text-white py-20" data-testid="blog-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">Our Blog</h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Expert insights, tips, and the latest trends in drip irrigation and sustainable farming
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-24 bg-[#F1F8E9]" data-testid="blog-posts-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="text-center py-20" data-testid="loading-spinner">
              <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-[#2E7D32] border-t-transparent"></div>
              <p className="mt-4 text-[#4E5D50]">Loading blog posts...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center py-20 bg-white rounded-2xl" data-testid="no-blogs">
              <h2 className="text-2xl font-bold text-[#1B3322] mb-4">No Blog Posts Yet</h2>
              <p className="text-[#4E5D50]">
                We're working on bringing you valuable content. Check back soon!
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
              {blogs.map((blog) => (
                <article
                  key={blog.id}
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all group"
                  data-testid="blog-card"
                >
                  <div className="relative overflow-hidden aspect-[16/10]">
                    <img
                      src={blog.image_url}
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-sm text-[#839385] mb-3">
                      <span className="flex items-center gap-1">
                        <FaUser className="text-xs" />
                        {blog.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <FaCalendarAlt className="text-xs" />
                        {formatDate(blog.created_at)}
                      </span>
                    </div>
                    <h2 className="text-xl font-bold mb-3 text-[#1B3322] group-hover:text-[#2E7D32] transition-colors">
                      {blog.title}
                    </h2>
                    <p className="text-[#4E5D50] mb-4 line-clamp-3">{blog.excerpt}</p>
                    <Link
                      to={`/blog/${blog.id}`}
                      className="inline-flex items-center space-x-2 text-[#2E7D32] font-semibold hover:space-x-3 transition-all"
                      data-testid="read-more-link"
                    >
                      <span>Read More</span>
                      <FaArrowRight className="text-sm" />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;